import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function aboutus() {

    return (



        <div>

            <div className='container-fluid impression'>
                <div>
                    <ol className="breadcrumb float-xl-right">
                        <li className="breadcrumb-item"><a href="/home">Home</a></li>
                        <li className="breadcrumb-item active">About us</li>
                    </ol>
                    <h1 className="page-header">About us</h1>
                </div>
                <div className='liststyletype mt-5'>
                    <h4 className='mb-3'>STT_ Scan to Tell is owned by</h4>
                    <p className='mb-4' >4 MB Technologies <br />Stentenberg st 31 pt <br />51702 Bergneustadt<br />Germany</p>
                    <h5 className='mb-2'>Want to get in touch with us, send us email at
                        <a href="mailto: info@arcode-stt.com"> info@qrcode-stt.com</a>
                    </h5>
                    <h5>Want Want to know more about us, visit our website
                        <a target='_blank' href="https://lifetags.io/" > www.lifetags.io</a>
                    </h5>
                </div>

            </div>
        </div>
        // <div>

        //     <div className='container-fluid impression'>
        //         <div>
        //             <ol className="breadcrumb float-xl-right">
        //                 <li className="breadcrumb-item"><a href="/dashboard/home">Home</a></li>
        //                 <li className="breadcrumb-item active">About us</li>
        //             </ol>
        //             <h1 className="page-header">About us</h1>
        //         </div>

        //         <div className='row mt-4'>
        //             <div className='col-md-12 emailtext'>
        //             <h4 className="page-header">STT_ Scan to Tellis owned by</h4>
        //             </div>
        //         </div>
        //         <div className='row mt-4'>
        //             <div className='col-md-12 emailtext'>
        //                 <p>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
        //             </div>
        //         </div>
        //         <div className='row mt-2'>
        //             <div className='col-md-12 emailtext'>
        //                 <ul>
        //                     <li>What is Lorem Ipsum?</li>
        //                     <li>Why do we use it?</li>
        //                     <li>Where does it come from?</li>
        //                     <li>Where can I get some?</li>
        //                 </ul>
        //             </div>
        //         </div>
        //         <div className='row '>
        //             <div className='col-md-12 emailtext'>
        //                 <p>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )

}

export default aboutus;